"use strict";

export default function iconsConfig (queryParamGetter, iceApplicationIconsProvider) {
  "ngInject";

  // Previene la configurazione delle icone: utile per verificare quali componenti non utilizzano icone dinamiche
  const forceEmptyIconsDef = !! queryParamGetter("iceNoIcons", true);

  /*
  * I valori delle icone possono rimandare ad altre icone se iniziano con $
  * Se i valori delle icone finiscono con "!default" verranno ignorati nel caso fossero gia stati definiti (come sass)
  *
  * @use:
  * <i ice-application-icon="" icon-name="fecon.mailbox.message.compose"></i>
  * */

  let icons = {

    /*
     * ### Generic
     */
    "icon.fecon.basic.caret": "caret", // default bootstrap
    "icon.fecon.basic.info": "glyphicon glyphicon-info-sign",
    "icon.fecon.basic.file": "glyphicon glyphicon-file",
    "icon.fecon.basic.dropdown.open": "glyphicon glyphicon-chevron-up",
    "icon.fecon.basic.dropdown.closed": "glyphicon glyphicon-chevron-down",
    "icon.fecon.basic.checkbox.checked": "glyphicon glyphicon-check",
    "icon.fecon.basic.checkbox.unchecked": "glyphicon glyphicon-unchecked",
    "icon.fecon.basic.tree-item.open": "glyphicon glyphicon-chevron-down",
    "icon.fecon.basic.tree-item.closed": "glyphicon glyphicon-chevron-right",

    "icon.fecon.basic.modal.confirm-icon": "glyphicon glyphicon-question-sign", //ale
    "icon.fecon.basic.modal.actions.close": "$ icon.fecon.actions.close",

    "icon.fecon.actions.add": "glyphicon glyphicon-plus",
    "icon.fecon.actions.edit": "glyphicon glyphicon-pencil",
    "icon.fecon.actions.close": "glyphicon glyphicon-remove",
    "icon.fecon.actions.remove": "glyphicon glyphicon-remove",
    "icon.fecon.actions.delete": "glyphicon glyphicon-trash",
    "icon.fecon.actions.trash": "glyphicon glyphicon-trash",
    "icon.fecon.actions.all-selected": "$ icon.fecon.basic.checkbox.checked",
    "icon.fecon.actions.not-all-selected": "$ icon.fecon.basic.checkbox.unchecked",
    "icon.fecon.actions.refresh": "glyphicon glyphicon-refresh",
    "icon.fecon.actions.reload": "$ icon.fecon.actions.refresh",
    "icon.fecon.actions.ordering": "glyphicon glyphicon-sort",
    "icon.fecon.actions.prev": "glyphicon glyphicon-chevron-left",
    "icon.fecon.actions.next": "glyphicon glyphicon-chevron-right",
    "icon.fecon.actions.options": "glyphicon glyphicon-option-horizontal",
    "icon.fecon.actions.contextual-opener": "glyphicon glyphicon-option-vertical",


    /*
     * ### Application main
     */
    "icon.fecon.main.actions.settings": "glyphicon glyphicon-cog",
    "icon.fecon.main.actions.help": "glyphicon glyphicon-question-sign",
    "icon.fecon.main.actions.account": "glyphicon glyphicon-user",
    "icon.fecon.main.actions.account-settings": "glyphicon glyphicon-user",
    "icon.fecon.main.actions.my-mailbox": "$ icon.fecon.mailbox.navbar-module",
    "icon.fecon.main.actions.logout": "glyphicon glyphicon-off",


    /*
     * ### Online Guide
     */
    "icon.fecon.guide.back": "glyphicon glyphicon-menu-left",
    "icon.fecon.guide.pathSeparator": "glyphicon glyphicon-menu-right",
    "icon.fecon.guide.home": "glyphicon glyphicon-home",
    "icon.fecon.guide.download": "glyphicon glyphicon-download-alt",



    /*
     * ### Examples: Todos Scenes
     */
    "icon.fecon.examples.todos.navigation-module": "glyphicon glyphicon-book",
    "icon.fecon.examples.todos.primary-action--create-todo": "$ icon.fecon.actions.add",

    "icon.fecon.examples.todos.create": "glyphicon glyphicon-edit",
    "icon.fecon.examples.todos.refresh": "$ icon.fecon.actions.refresh",
    "icon.fecon.examples.todos.filter": "",

    "icon.fecon.examples.todos.delete": "$ icon.fecon.actions.trash",
    "icon.fecon.examples.todos.edit": "$ icon.fecon.actions.tras",



    /*
     * ### Application FeatureX Scenes
     */
    "icon.infocertLmrc.feature-x.icon-name": "glyphicon glyphicon-info-sign",
    "icon.lmrc.pec-import.calendar": "glyphicon glyphicon-calendar",



  };


  if (forceEmptyIconsDef) {
    icons = {};
  }

  iceApplicationIconsProvider.setIcons(icons);

}



// WEBPACK FOOTER //
// ./client/app/app.config/icons.config.js